var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
const customEl = "stepper-bar";
let StepperBar = class StepperBar extends LitElement {
    constructor() {
        super(...arguments);
        this.progress = 0;
    }
    render() {
        return html `<div style=${styleMap({ "--bar-progress": this.progress + "%" })}></div>`;
    }
};
StepperBar.styles = css `
:host {
    contain: paint;
}
div {
    width: 100%;
    height: 100%;
    transform: translateX(var(--bar-progress));
    background-color: var(--bar-bgcolor, black);
}
`;
__decorate([
    property({ attribute: false }),
    __metadata("design:type", Number)
], StepperBar.prototype, "progress", void 0);
StepperBar = __decorate([
    customElement(customEl)
], StepperBar);
export { StepperBar };
